import { z } from 'zod';
import { Currency } from 'types/general';
import { CompanyStatus } from 'store/companies';
import {
  depositsFiltersSchema,
  transactionsFiltersSchema,
  transmissionActsFiltersSchema,
} from './transmission-acts.schemas';

export const transmissionActListVariants = [
  'reports',
  'balance',
  'deposits',
] as const;
export type TransmissionActListVariant =
  (typeof transmissionActListVariants)[number];

export interface BaseTransmissionAct {
  id: string;
  sequence: number;
  company: {
    id: string;
    name: string;
    status: CompanyStatus;
  } | null;
  billingInfo: string;
  from: string;
  to: string | null;
  openingBalance: number;
  closingBalance: number;
}

export interface TransmissionAct extends BaseTransmissionAct {
  balance: {
    deposits: {
      total: number;
      transactions: Array<{
        title: string;
        amount: number;
        currency: Currency;
        date: string;
      }>;
    };
    expenses: {
      total: number;
      transactions: Array<{
        title: 'marketplaceOrder' | 'reimbursementClaim';
        amount: number;
        currency: Currency;
        count: number;
      }>;
    };
  };
}

export type Transaction =
  | {
      type: 'deposit';
      id: string;
      title: string;
      amount: number;
      currency: Currency;
      date: string;
      balance: number;
    }
  | {
      type: 'expense';
      id: string;
      title: string;
      amount: number;
      currency: Currency;
      count: number;
      balance: number;
    };

export interface Deposit {
  id: string;
  date: string;
  amount: number;
  currency: Currency;
  accountNumber: string;
  company: { id: string; name: string } | null;
}

export type TransmissionActsFilters = z.infer<
  typeof transmissionActsFiltersSchema
>;

export type TransactionsFilters = z.infer<typeof transactionsFiltersSchema>;

export type DepositsFilters = z.infer<typeof depositsFiltersSchema>;
